export default __webpack_public_path__ + "static/media/ecBg.46f7384f.jpg";